var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',[_c('v-container',{attrs:{"fluid":"","id":"home-container"}},[_c('Header'),_c('Main'),_c('Statistics'),_c('hr',{staticStyle:{"width":"100%","opacity":"0.2"}}),_c('Footer')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }